<p-toast position="top-right"></p-toast>
<div class="p-g req-management">
  <div class="p-g-12">
    <div class="card card-w-title" [ngClass]="{ 'loading': loading }">

      <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
          styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
      </div>

      <h1 class="req-Title" style="padding-top: 20px; padding-left: 10px;">{{setLabel("requestsManagementLabel")}}</h1>

      <p-table #dt [value]="requests" dataKey="id" styleClass="p-table-customers req-management-table "
        [rowHover]="true" [rows]="100" [showCurrentPageReport]="true" [loading]="loading" [paginator]="true"
        currentPageReportTemplate="There are {{requests?.length}} records" [filterDelay]="0"
        [globalFilterFields]="['name','country.name','representative.name','status']" class="p-table-tecfolk-fix">

        <ng-template pTemplate="caption">
          <div class="reportMainFilter">

            <div class="reportMainFields">
              <div class="filterFields">
                <span class="fieldTitle" for="">{{setLabel("searchRequestByNameLabel")}}</span>
                <input pinputtext="" [(ngModel)]="searchValue" autocomplete="off" [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text"
                  name="searchValue" (keyup)="searchLocal(searchValue)"
                  class="p-inputtext p-corner-all p-state-default p-widget">

              </div>
              <div class="filterFields">
                <span class="fieldTitle" for="">{{setLabel("statusLabel")}}</span>
                <p-dropdown class="p-inputtext" [options]="statusOptions" [placeholder]='setLabel("selectPlaceholderLabel")' name="selectStatus"
                  [style]="{'width':'100%'}" required [(ngModel)]="statusOptionValue" (ngModelChange)="getRequests()">
                </p-dropdown>
              </div>
              <div class="filterFields">
                <span class="fieldTitle" for="">{{setLabel("requestTypeLabel")}}</span>
                <p-dropdown class="p-inputtext" [options]="requestTypeOptions" [placeholder]='setLabel("selectPlaceholderLabel")'
                  name="selectRequestType" [style]="{'width':'100%'}" required [(ngModel)]="requestTypeOptionValue"
                  (ngModelChange)="getRequests()">
                </p-dropdown>

              </div>
              <div style="display: flex; align-items: center; gap: 20px; justify-content: space-around;">
                <span [pTooltip]='setLabel("searchTooltipLabel")' tooltipPosition="top" [disabled]="loading" [(ngModel)]="searchValue"
                  (click)="searchLocal(searchValue)"><i class="fa fa-search"></i></span>
                <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" [disabled]="loading"
                  (click)="resetFilter()"> <i class="pi pi-times"></i></span>
              </div>

            </div>

            <!-- <div>
              <button style="background:#ffffff; color: #0e2031;" (click)="resetFilter()"
              class="p-button p-widget p-state-default p-corner-all p-button-text-only">Clear</button>
            </div> -->

          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="text-align: center;">{{setLabel("requestNoLabel")}}</th>
            <th style="text-align: center;">{{setLabel("nameLabel")}}</th>
            <th style="text-align: center;">{{setLabel("mobileLabel")}}</th>
            <th style="text-align: center;">{{setLabel("CNICLabel")}}</th>
            <th style="text-align: center;">{{setLabel("requestTypeLabel")}}</th>
            <th style="text-align: center;">{{setLabel("requestDateLabel")}}</th>
            <th style="text-align: center; width: 122px;">{{setLabel("requestStatusLabel")}}</th>
            <th class="photoHeight" style="text-align: center;">{{setLabel("photoLabel")}}</th>
            <th class="actionbtn">{{setLabel("actionLabel")}}</th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-requestor>
          <tr *ngIf="!(requestor.requestType === 'Registration' && !requestor.isComplete)" class="p-selectable-row ">
            <td style="text-align: center;">
              <div class="req-Lable">{{setLabel("requestNoLabel")}}</div>
              <span class="p-column-title">{{requestor.requestId}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> {{setLabel("nameLabel")}} </div>
              <span class="p-column-title">{{requestor.name}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> {{setLabel("mobileLabel")}} </div>
              <span class="p-column-title">{{requestor?.contactDetail?.contact}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> {{setLabel("CNICLabel")}} </div>
              <span *ngIf="requestor.requestType == 'FeeSubmission'"
                class="p-column-title">{{requestor?.feeSubmissionDetail.CNIC}}</span>
              <span *ngIf="requestor.requestType == 'Registration'"
                class="p-column-title">{{requestor?.registrationDetail.CNIC}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> {{setLabel("requestTypeLabel")}} </div>
              <span class="p-column-title">{{requestor.requestType}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable"> {{setLabel("requestDateLabel")}} </div>
              <span class="p-column-title">{{requestor.requestDate | date:'medium'}}</span>
            </td>
            <td style="text-align: center;">
              <div class="req-Lable">{{setLabel("requestStatusLabel")}} </div>
              <span>{{requestor?.requestStatus}}</span>
            </td>
            <td *ngIf="requestor.requestType === 'Registration'" style="text-align: center;">
              <div class="req-Lable"> {{setLabel("photoLabel")}} </div>

              <img [alt]="" [src]="
                            requestor?.profile
                                ? config?.Server + config.memberImagePath + requestor?.profile
                                : requestor?.gender && requestor?.gender == 'F'
                                ? 'assets/layout/images/avatarGirlImage.png'
                                : 'assets/layout/images/avatarBoyImage.png'
                        " width="70" height="70" style="vertical-align: middle; border-radius: 100%;" />
            </td>
            <td *ngIf="requestor.requestType === 'Visitor'" style="text-align: center;">
              <div class="req-Lable"> {{setLabel("photoLabel")}} </div>
              <img [alt]="" [src]="'assets/layout/images/avatarBoyImage.png'" width="70" height="70"
                style="vertical-align: middle; border-radius: 100%;" />
            </td>
            <td *ngIf="requestor.requestType === 'FeeSubmission'" style="text-align: center;">
              <div class="req-Lable"> {{setLabel("photoLabel")}} </div>
              <img [alt]="" [src]="
                          requestor?.feeSubmissionDetail.feeReceiptImageUrl
                              ? config?.Server + config.feereceiptImagePath + requestor?.feeSubmissionDetail.feeReceiptImageUrl
                              : requestor?.gender && requestor?.gender == 'F'
                              ? 'assets/layout/images/avatarGirlImage.png'
                              : 'assets/layout/images/avatarBoyImage.png'
                             " width="70" height="70" />
            </td>
            <td *ngIf="requestor.requestType === 'OnlineRegistrationFee'" style="text-align: center;">
              <div class="req-Lable"> {{setLabel("photoLabel")}} </div>
              <img [alt]="" [src]="
                          requestor?.feeSubmissionDetail.feeReceiptImageUrl
                              ? config?.Server + config.feereceiptImagePath + requestor?.feeSubmissionDetail.feeReceiptImageUrl
                              : requestor?.gender && requestor?.gender == 'F'
                              ? 'assets/layout/images/avatarGirlImage.png'
                              : 'assets/layout/images/avatarBoyImage.png'
                             " width="70" height="70" />
            </td>

            <!-- style="text-align: end;padding-right: 2em; display: flex;gap: 3px;
                        padding-left: 2em; margin-top: 1.5em; justify-content: center;" -->

            <td class="actionbtn-main"
              style="text-align: end; display: flex; justify-content: start; width: auto; flex-direction: row; margin-top: 18px">

              <div class="req-Lable">{{setLabel("actionLabel")}}</div>
              <!-- <button pButton type="button" pTooltip="Delete Request" class="p-button-danger p-button" icon="fa fa-times" (click)="deleteRequest(requestor)"></button> &nbsp; -->
              <button pButton type="button" style="width: 2%; border-radius: 100%;" [pTooltip]='setLabel("rejectRequestTooltipLabel")' tooltipPosition="top"
                class="p-button-danger p-button" icon="fa fa-times" (click)="reject(requestor)"></button> &nbsp;
              <button pButton type="button" style="width: 2%; border-radius: 100%;" [pTooltip]='setLabel("viewRequestDetailsTooltipLabel")' tooltipPosition="top"
                icon="fa fa-pencil-square-o" routerLink="request-detail/{{requestor._id}}"></button>
              <!-- <ng-template #elseRole>
              <button pButton type="p-button-teal p-button" style="background-color: #009688;"
                icon="fa fa-shield"></button>
            </ng-template>
            <button pButton type="button" icon="fa fa-pencil-square-o" (click)="viewRole(rowData)"></button> -->

              <!-- <button pButton type="button" pTooltip="Add Member Fee"
                *ngIf="requestor.isDelete === false && customer.freezeDetail.isFreeze === false"
                class="p-button-primary p-button" icon="fa fa-money" style="background: #1ab394"
                (click)="showDialog(requestor)"></button>
              <button pButton type="button" pTooltip="Freeze Member"
                *ngIf="customer.isDelete === false && customer.freezeDetail.isFreeze == false"
                class="p-button-primary p-button" icon="fa fa-thermometer-empty" style="background: #03A9F4"
                (click)="freezeMember(customer)"></button>
              <button type="button" *ngIf="customer.isDelete === true" class="myCustomerBtn"
                (click)="activateMember(customer)">
                <i class="fa fa-exclamation-circle" pTooltip="Activate Member"
                  aria-hidden="true"></i>&nbsp;&nbsp;Activate</button>
              <button type="button" *ngIf="customer.freezeDetail.isFreeze === true" class="myCustomerBtn"
                (click)="defreezeMember(customer)">
                <i class="fa fa-exclamation-circle" pTooltip="Defreeze Member"
                  aria-hidden="true"></i>&nbsp;&nbsp;Defreeze</button>
              <button pButton type="button" pTooltip="Deactivate Member"
                *ngIf="customer.isDelete === false && customer.freezeDetail.isFreeze === false" icon="fa fa-user-times"
                (click)="deActivateMember(customer)"></button> -->
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" style="text-align:left">{{setLabel("noRequestsFoundLabel")}}</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="content reportSummary" style="width: min-content; margin-left: auto;">
        <p-table [value]="tableData">
          <ng-template pTemplate="header">
            <tr>
              <th>&nbsp;</th>
              <th><strong>{{setLabel("pendingLabel")}}</strong></th>
              <th><strong>{{setLabel("approvedLabel")}}</strong></th>
              <th><strong>{{setLabel("rejectedLabel")}}</strong></th>
              <th><strong>{{setLabel("totalLabel")}}</strong></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
              <td>{{ rowData.column1 }}</td>
              <td>{{ rowData.Pending }}</td>
              <td>{{ rowData.Approved }}</td>
              <td>{{ rowData.Rejected }}</td>
              <td>{{ rowData.Total }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td></td>
              <td></td>
              <td colspan="2">{{setLabel("overallTotalLabel")}}</td>
              <td>{{overAllTotal}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<!-- <p-dialog header="Add Fee" [(visible)]="dialogVisibility">
  <form #feeForm="ngForm" style="height: 250px; width: 570px;">
    <div class="p-g-12 p-md-12">
      <div class="p-inputgroup">
        <p-dropdown [options]="feesOptions" name="status" (onChange)="feeChange()" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.status">
        </p-dropdown>
        <p-dropdown [options]="months" (onChange)="feeChange()" name="months" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.month">
        </p-dropdown>
        <p-dropdown [options]="years" (onChange)="feeChange()" name="year" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.year">
        </p-dropdown>
      </div>
    </div>
    <div class="p-g-12 p-md-12">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">PKR </span>
        <input type="number" style="width: 100% !important;" required pattern="[0-9]+" autocomplete="off" pInputText
          placeholder="Price" name="fundPay" [(ngModel)]="fund.pay" #fundPay="ngModel" (input)="checkfeegreater()"
          [ngClass]="fundPay.invalid && (fundPay.dirty || fundPay.touched) ? 'errorInput' : '' ">
        <span class="p-inputgroup-addon">.00</span>
      </div>
      <div *ngIf="fundPay.invalid && (fundPay.dirty || fundPay.touched)">
        <div *ngIf="fundPay.errors.required" class="errorShow">
          Please Enter Fee Correctly.
        </div>
        <div *ngIf="fundPay.errors.pattern" class="errorShow">
          Please Enter Fee Correctly.
        </div>
      </div>
    </div>
    <p-footer>
      <button (click)="addFund()" [disabled]="!feeForm.valid || feegreater==true || feealreadypaid==true" pButton
        type="button" label="Save" icon="pi pi-save" class="p-button-success"></button>
        <br>
        <br>
        <div class="alert alert-danger">
          <p-message severity="error" text="Fee already paid" *ngIf="feealreadypaid"></p-message>
        </div>
        <div class="alert alert-danger">
          <p-message severity="error" text="You cannot pay more than actual Fee" *ngIf="feegreater"></p-message>
        </div>
    </p-footer>
  </form>
</p-dialog> -->